import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import { Navbar, Footer } from './container';
import { Home, Media, Contact, Comingsoon, Error } from './pages';
import './App.scss';



const App = () => {


    return (
<>
<Router>
        <div id="home" className="App">
                    
                    <Navbar />

                    <Routes>
                        <Route exact path="/" element={<Home />} />
                        <Route path="/media" element={<Media />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/coming-soon" element={<Comingsoon />} />
                        <Route path="/error" element={<Error />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                <Footer />
                    
        </div>
</Router>        
</>
    );
}

export default App;